import React, { useContext, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  getWishlist,
  DeleteFromWishList,
  AddItemToCart,
  getProductQty,
} from "../services/Cart";
import "../styles/Wishlist.css";
import noimage from "../assets/noimage.webp";
import AuthModal from "../comopnents/AuthModal.jsx";
import { showSnackbar } from "./snackbar";
import LoadingSpinner from "./LoadingSpinner";
import { CartContext } from "../contextApi/CartContext";
import { withImageVersion } from "../contextApi/ImageVersionContext";
import CartQuantityControl from "./CartQuantityControl";
import PurchaseOptionsModal from "./PurchaseOptionsModal";
import {
  buildCartPurchaseData,
  buildEnhancedPurchaseData,
  getMinOrderQty,
  getMinimumPurchaseQuantity,
  getPurchaseQuantityStep,
  getSavedCartPurchaseData,
  shouldShowPurchaseModal,
} from "../utils/purchaseOptions";

import { Notifyed } from "../services/Auth";
import { isOutOfStock } from "../utils/stock";
const Wishlist = ({ onUpdateCount }) => {

  const { addToCart, itemList, setCartQty } = useContext(CartContext);
  const [wishlist, setWishlist] = useState([]);
  const [showPurchaseModal, setShowPurchaseModal] = useState(false);
  const [pendingPurchaseProduct, setPendingPurchaseProduct] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const [showAuthModal, setShowAuthModal] = useState(false);

  /* ================= FETCH WISHLIST ================= */
  useEffect(() => {
    fetchWishlist();
  }, []);

  useEffect(() => {
    if (onUpdateCount) {
      onUpdateCount(wishlist.length);
    }
  }, [wishlist, onUpdateCount]);

  const fetchWishlist = async () => {
    try {
      setLoading(true);
      const userId = localStorage.getItem("userId");

      if (!userId) {
        setError("Please login to view your wishlist");
        return;
      }

      const response = await getWishlist(userId);

      if (response?.Data && Array.isArray(response.Data)) {
        setWishlist(response.Data);
      } else if (Array.isArray(response)) {
        setWishlist(response);
      } else {
        setWishlist([]);
      }
    } catch (err) {
      console.error(err);
      setError("Failed to load wishlist");
    } finally {
      setLoading(false);
    }
  };

  const handleNotifyMe = async (productid) => {
    const userId = localStorage.getItem("userId");

    // If not logged in → open login modal
    if (!userId) {
      showSnackbar("info", "Please login to receive notifications");
      //  setPendingCart({ product, purchaseType });
      setShowAuthModal(true);
      return;
    }

    try {
      const response = await Notifyed({
        customerid: userId,
        productid: productid,
      });

      console.log("Notify me success:", response);
      showSnackbar("success", "We will notify you when product is available");
    } catch (error) {
      console.error("Notify me error:", error.response?.data || error.message);
      showSnackbar("error", "Failed to register notify request");
    }
  };

  /* ================= NAVIGATION ================= */
  const goToProductDetail = (productId) => {
    navigate(`/productdetail?productid=${productId}`);
  };

  /* ================= DELETE WISHLIST ================= */
  const handleDeleteWishList = async (productid) => {
    try {
      const userId = localStorage.getItem("userId");
      if (!userId) return;

      await DeleteFromWishList({
        customerid: userId,
        productid,
      });

      setWishlist((prev) =>
        prev.filter((item) => item.productid !== productid),
      );
    } catch (err) {
      console.error("Delete wishlist error:", err);
    }
  };

  const openPurchaseModal = (product) => {
    const userId = localStorage.getItem("userId");
    if (!userId) {
      showSnackbar("info", "Please login to add items to cart");
      navigate("/login");
      return;
    }

    if (!shouldShowPurchaseModal(product)) {
      handleAddToCart(product, product?.productname, getMinOrderQty(product));
      return;
    }
    setPendingPurchaseProduct(product);
    setShowPurchaseModal(true);
  };

  const confirmPurchaseType = async (purchaseType, couponData) => {
    if (!pendingPurchaseProduct) return;
    const purchaseData = buildEnhancedPurchaseData(pendingPurchaseProduct, purchaseType, couponData);
    await handleAddToCart(pendingPurchaseProduct, pendingPurchaseProduct?.productname, purchaseData.quantity, purchaseData);
    setShowPurchaseModal(false);
    setPendingPurchaseProduct(null);
  };

  /* ================= ADD TO CART ================= */
  const handleAddToCart = async (product, productName, qty = 1, purchaseData = null) => {
    try {
      const productid = product?.productid || product;
      if (isOutOfStock(product)) {
        await handleNotifyMe(productid);
        return;
      }

      const userId = localStorage.getItem("userId");
      if (!userId) return;

      await AddItemToCart({
        customerid: userId,
        productid,
        qty,
        stock: product?.stock,
      });
      addToCart(productid, qty, purchaseData);

      await DeleteFromWishList({
        customerid: userId,
        productid,
      });

      setWishlist((prev) =>
        prev.filter((item) => item.productid !== productid),
      );

      showSnackbar("success", `item added to cart`);
    } catch (err) {
      console.error("Add to cart error:", err);
      showSnackbar("error", "Failed to add item to cart");
    }
  };

  const handleCartQtyChange = async (productid, qty) => {
    try {
      const userId = localStorage.getItem("userId");
      if (!userId) return;

      await getProductQty({ user_id: userId, productid, qty });
      setCartQty(productid, qty);
    } catch (err) {
      console.error("Update cart qty error:", err);
      showSnackbar("error", "Failed to update quantity");
    }
  };

  /* ================= UI STATES ================= */
  if (loading) {
    return <LoadingSpinner text="Loading wishlist..." />;
  }

  if (error) {
    return <p style={{ textAlign: "center", color: "red" }}>{error}</p>;
  }

  if (wishlist.length === 0) {
    return (
      <div className="empty-state">
        <h3>Your wishlist is empty </h3>
        <button
          onClick={() => navigate("/")}
          style={{
            padding: "8px 15px",
            backgroundColor: "#005487",
            color: "#ffffff",
            border: "none",
            borderRadius: "25px",
            fontSize: "16px",
            fontWeight: "600",
            cursor: "pointer",
            transition: "all 0.3s ease",
            boxShadow: "0 4px 10px rgba(0, 84, 135, 0.3)",
          }}
        >
          Browse Products
        </button>
      </div>
    );
  }

  /* ================= RENDER ================= */
  return (
    <div className="wishlist-container">
      <h2>My Wishlist ({wishlist.length})</h2>

      <div className="wishlist-grid">
        {wishlist.map((item) => {
          const product = item?.dtl?.[0] || {};

          const productImage = withImageVersion(product.image1?.trim() || product.image2?.trim()) || noimage;
          const displayModelNo = product.displaymodelno || "No Model";

          const mrp = product.mrp || 0;
          const netRate = product.netrate || 0;
          const discount = product.discount || 0;
          const stock = product.stock || 0;
          const cartQty =
            itemList.find(
              (cartItem) => String(cartItem.productId) === String(product.productid),
            )?.count || 0;
          const minorderqty = product.minorderqty || product.dtl?.[0]?.minorderqty || 1;
          const savedPurchaseData = getSavedCartPurchaseData(product.productid);
          const purchaseType = savedPurchaseData?.purchaseType || "piece";

          return (
            <div className="wishlist-card" key={item.id}>
              {/* IMAGE */}
              <div className="card-image-container">
                <img
                  src={productImage}
                  onError={(e) => (e.target.src = noimage)}
                  alt={displayModelNo}
                  className="card-image"
                  onClick={() => goToProductDetail(product.productid)}
                />

                {((stock > 0 && Number(product.netrate) > 0) || discount > 0) && (
                  <span className="discount-badge">
                    {stock > 0 && Number(product.netrate) > 0 ? "Netrate" : `${discount}% OFF`}
                  </span>
                )}

                <button
                  className="remove-wishlist-btn"
                  onClick={() => handleDeleteWishList(item.productid)}
                >
                  ✖
                </button>
              </div>

              {/* BODY */}
              <div className="card-bodyy">
                <p className="card-category">
                  {product.brand}
                </p>
                <p className="card-category">
                  {product.category || product.subcategory}
                </p>

                {product.displaymodelno && (
                  <p className="card-model">Model: {product.displaymodelno}</p>
                )}

                <div className="card-price-section">
                  {product.mrp && Number(product.netrate) <= 0 && (
                    <div
                      style={{
                        textDecoration: "line-through",
                        color: "#888",
                        fontSize: "14px",
                      }}
                    >
                      MRP:₹{Number(product.mrp).toFixed(2)}
                    </div>
                  )}

                  {/* Discounted Price */}
                  {Number(product.netrate) > 0 ? (
                    <div
                      style={{
                        fontWeight: 500,
                        fontSize: "14px",
                        color: "#000",
                      }}
                    >
                      Rs. {Number(product.netrate).toFixed(2)}
                    </div>
                  ) : product.mrp && product.discount ? (
                    <div
                      style={{
                        fontWeight: 500,
                        fontSize: "14px",
                        color: "#000",
                      }}
                    >
                      ₹
                      {(
                        Number(product.mrp) -
                        (Number(product.mrp) * discount) / 100
                      ).toFixed(2)}
                    </div>
                  ) : product.mrp ? (
                    <div
                      style={{
                        fontWeight: 500,
                        fontSize: "14px",
                        color: "#000",
                      }}
                    >
                      MRP:₹{Number(product.mrp).toFixed(2)}
                    </div>
                  ) : null}
                </div>
              </div>

              {/* FOOTER */}
              <div className="card-footerr">
                {stock > 0 && cartQty > 0 ? (
                  <CartQuantityControl
                    qty={cartQty}
                    minQty={getMinimumPurchaseQuantity(product, purchaseType)}
                    step={purchaseType !== "piece" ? getPurchaseQuantityStep(product, purchaseType) : undefined}
                    stock={stock}
                    purchaseType={purchaseType}
                    product={product}
                    onChange={(newQty) =>
                      handleCartQtyChange(product.productid, newQty)
                    }
                    className="qty-box"
                  />
                ) : (
                  <button
                    style={{
                      marginLeft:'18px',
                      marginBottom:'18px',
                      width: "85%",
                      padding: "7px",
                      margin: "8px 15",
                      borderRadius: "25px",
                      border: "none",
                      fontWeight: "600",
                      backgroundColor: product.stock > 0 ? "#005487" : "#e0e0e0",
                      color: product.stock > 0 ? "#ffffff" : "#777777",
                    }}
                    onClick={() =>
                      product.stock > 0
                        ? openPurchaseModal(product)
                        : handleNotifyMe(product.productid)
                    }
                  >
                    {product.stock > 0 ? "Add to Cart" : "Notify Me"}
                  </button>
                )}
              </div>
            </div>
          );
        })}
      </div> 
       {showAuthModal && (
        <AuthModal
          initialMode="login"
          onClose={() => setShowAuthModal(false)}
          onSuccess={handleAuthSuccess}
        />
      )}
      <PurchaseOptionsModal
        isOpen={showPurchaseModal}
        product={pendingPurchaseProduct}
        onClose={() => {
          setShowPurchaseModal(false);
          setPendingPurchaseProduct(null);
        }}
        onConfirm={confirmPurchaseType}
      />
    </div>
  );
};

export default Wishlist;
